import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import {
  SensaiPage,
  SensaiArticle,
  SensaiLandingPages,
} from "../gql/generated/graphql"
import { getSrc } from "gatsby-plugin-image"

export const Head = ({
  location,
  data,
  pageContext,
  children,
}: {
  location: { pathname: string }
  data: {
    sensaiPage?: SensaiPage
    sensaiLandingPages?: SensaiLandingPages
    sensaiArticle?: SensaiArticle
  }
  pageContext: {
    canonicalUrls?: string[]
    slug: string
    indexStorePage?: boolean
    isLandingPage?: boolean
  }
  children: any
}) => {
  const { pathname } = location
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            defaultTitle: title
            titleTemplate
            defaultDescription: description
            defaultImage: image
            siteUrl
            author
          }
        }
      }
    `
  )

  const {
    defaultTitle,
    defaultDescription,
    siteUrl,
    defaultImage,
    author,
  } = site.siteMetadata

  const page = data.sensaiArticle ?? data.sensaiPage ?? data.sensaiLandingPages
  const image = getSrc(
    page?.seo?.metaImage?.imageFile?.childImageSharp?.gatsbyImageData
  )

  return (
    <html lang="en">
      <title id="pagetitle">{page?.title ?? "Sens.ai"}</title>
      <meta
        id="metatitle"
        name="title"
        property="og:title"
        content={page?.seo?.metaTitle ?? defaultTitle}
      />
      <meta
        id="metadescription"
        name="description"
        property="og:description"
        content={page?.seo?.metaDescription ?? defaultDescription}
      />

      <meta
        name="image"
        property="og:image"
        content={`${siteUrl}${image || defaultImage}`}
      />

      <meta name="type" property="og:type" content="website" />

      <meta name="url" property="og:url" content={`${siteUrl}${pathname}`} />

      <meta
        name="twitter:title"
        content={page?.seo?.metaTitle ?? defaultTitle}
      />
      <meta name="twitter:creator" content={author || ``} />

      <meta
        name="twitter:description"
        content={page?.seo?.metaDescription ?? defaultDescription}
      />
      {pageContext.indexStorePage === false ||
        (pageContext.isLandingPage && <meta name="robots" content="noindex" />)}
      {pageContext.indexStorePage === true && (
        <meta name="robots" content="index, follow" />
      )}

      {pageContext.canonicalUrls &&
        pageContext.canonicalUrls.map(cl => (
          <link rel="canonical" href={siteUrl + cl} />
        ))}

      {/* Add ShareASale Master Tag to Head of every page */}
      <script
        src="https://www.dwin1.com/58409.js"
        type="text/javascript"
        defer={true}
      ></script>
      {children}
    </html>
  )
}
